import FeaturesContentSection from '../sections/FeaturesContentSection'
import ProductContentSection from '../sections/ProductContentSection'

import type { ProductSectionMegaMenu } from '@/utils/datocms/sectionTypes'
import OverviewSection from '../sections/OverviewSection'
import CtaBlockSection from '../sections/CtaBlockSection'
import FeatureCarouselSection from '../sections/FeatureCarouselSection'
import TestimonialSection from '../sections/TestimonialSection'
import FiftyFiftySection from '../sections/FiftyFiftySection'
import ServiceTileSection from '../sections/ServiceTileSection'
import AccordionsSection from '../sections/AccordionsSection'
import VideoSection from '../sections/VideoSection'
import TimelineSection from '../sections/TimelineSection'
import GridCardSection from '../sections/GridCardSection'
import MetricsSection from '../sections/MetricsSection'
import BenefitsSection from '../sections/BenefitsSection'
import ProductTileSection from '../sections/ProductTileSection'
import CarouselSection from '../sections/CarouselSection'

export default function ProductPageSection({
	section,
	inMegaMenu,
}: Readonly<ProductSectionMegaMenu>) {
	if (inMegaMenu) {
		switch (section.__typename) {
			case 'FeaturesContentSectionRecord':
				return <FeaturesContentSection {...section} inMegaMenu />
			case 'ProductContentRecord':
				return <ProductContentSection {...section} />
			default:
				return null
		}
	}

	switch (section.__typename) {
		case 'FeaturesContentSectionRecord':
			return <FeaturesContentSection {...section} />
		case 'ProductContentRecord':
			return <ProductContentSection {...section} />
		case 'OverviewRecord':
			return <OverviewSection {...section} />
		case 'CtaBlockRecord':
			return <CtaBlockSection {...section} />
		case 'FeatureCarouselRecord':
			return <FeatureCarouselSection {...section} />
		case 'TestimonialSectionRecord':
			return <TestimonialSection {...section} />
		case 'FiftyFiftySectionRecord':
			return <FiftyFiftySection {...section} />
		case 'ServiceTileRecord':
			return <ServiceTileSection {...section} />
		case 'AccordionsSectionRecord':
			return <AccordionsSection {...section} />
		case 'VideoSectionRecord':
			return <VideoSection {...section} />
		case 'TimelineSectionRecord':
			return <TimelineSection {...section} />
		case 'GridCardSectionRecord':
			return <GridCardSection {...section} />
		case 'MetricsSectionRecord':
			return <MetricsSection {...section} />
		case 'BenefitsSectionRecord':
			return <BenefitsSection {...section} />
		case 'ProductTileRecord':
			return <ProductTileSection {...section} />
		case 'CarouselSectionRecord':
			return <CarouselSection {...section} />

		default:
			return null
	}
}
